import * as React from "react"
import { Col, Row } from "react-grid-system"
import H3 from "../../../atoms/typography/H3"
import styled from "styled-components"
import { MediaQuery } from "../../../../utils/design-helpers"

const CircleContainer = styled.div`
  width: 50px;
  height: 50px;
  border-radius: 50%;
  border: 2px solid #c3c3c3;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-right: 4px;
`

const ItemContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;

  ${MediaQuery.XS} {
    padding: 8px;
  }
`

const SatcubeStarterPack: React.FC = () => {
  return (
    <Row nogutter align="center" justify="between">
      <H3>Satcube accessories starter pack:</H3>
      <ItemContainer>
        <CircleContainer>
          <img src="https://images.ctfassets.net/kzqg847wz5jr/3NC7Z7zqb1pH3UJIn8llgn/847455aab8043b4a9b03b90de3793a39/IMG-7111-Satcube-Studio-Photography-FQ-by-Sofia-Lewerin-1.png" />
        </CircleContainer>
        <H3>Hardcase</H3>
      </ItemContainer>
      <ItemContainer>
        <CircleContainer>
          <img src="https://images.ctfassets.net/kzqg847wz5jr/4nNXvmHjYnZ8jKPT1sFJZY/2f7b52122ba2e3ed99aaf20a3545d01f/IMG-7054-Satcube-Studio-Photography-FQ-by-Sofia-Lewerin-1.png" />
        </CircleContainer>
        <H3>3 batteries</H3>
      </ItemContainer>
      <ItemContainer>
        <CircleContainer>
          <img src="https://images.ctfassets.net/kzqg847wz5jr/51wAU0uYTDOKl1rM11JLgh/0479e3e64915fcec32742a52c4f761f4/IMG-7015-Satcube-Studio-Photography-FQ-by-Sofia-Lewerin-3.png" />
        </CircleContainer>
        <H3>Power supply</H3>
      </ItemContainer>
      <ItemContainer>
        <CircleContainer>
          <img src="https://images.ctfassets.net/kzqg847wz5jr/2gZUHAZRcR0n58t38Z73Hm/5ce02d2b9b2414339f117ffef314d86d/IMG-7070-Satcube-Studio-Photography-FQ-by-Sofia-Lewerin-3.png" />
        </CircleContainer>
        <H3>External charger</H3>
      </ItemContainer>
    </Row>
  )
}

export default SatcubeStarterPack
